import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWhitePrintIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    viewBox="0 0 19 19"
    {...props}
  >
    <path
      fill="#fff"
      d="M15.327 5.542H14.25V3.958a1.52 1.52 0 0 0-1.449-1.583H6.2A1.52 1.52 0 0 0 4.75 3.958v1.584H3.673a2.106 2.106 0 0 0-2.09 2.113v5.273a2.106 2.106 0 0 0 2.09 2.114h.681a1.584 1.584 0 0 0 1.584 1.583h7.125a1.583 1.583 0 0 0 1.583-1.583h.68a2.106 2.106 0 0 0 2.09-2.114V7.655a2.106 2.106 0 0 0-2.09-2.113M6.333 3.958h6.334v1.584H6.333zm-.395 11.084v-3.167h7.125v3.167zm9.895-2.114a.523.523 0 0 1-.506.53h-.681v-1.583a1.583 1.583 0 0 0-1.583-1.583H5.938a1.583 1.583 0 0 0-1.584 1.583v1.583h-.68a.523.523 0 0 1-.507-.53V7.655a.523.523 0 0 1 .506-.53h11.654a.523.523 0 0 1 .506.53z"
    />
  </svg>
);
export default SvgWhitePrintIcon;
